import { LinkingOptions } from './core'

/**
 * Screen name -> URL table. Navigators nest the same way (App is the drawer,
 * Media/Library/... are stacks inside it). react-router matches incoming URLs
 * against it (core/paths.ts) and the current screen's URL is generated from it.
 */
const linkingOptions: LinkingOptions = {
  config: {
    screens: {
      Login: 'login',
      // Outside the app drawer so the doclet renders with no MI6 chrome
      DocletPreview: 'doclets/:id/preview',
      NotFound: '*',
      App: {
        screens: {
          Media: {
            screens: {
              MediaList: 'media',
              MediaCreate: 'media/new',
              MediaEdit: 'media/:id/edit'
            }
          },
          Image: {
            screens: {
              ImageList: 'image'
            }
          },
          Library: {
            screens: {
              LibraryList: 'library',
              DocumentCreate: 'library/new',
              DocumentEdit: 'library/:id/edit'
            }
          },
          PageBuilder: {
            screens: {
              PageBuilderEdit: 'page-builder/:id?'
            }
          },
          Users: {
            screens: {
              UserList: 'users'
            }
          },
          ContentCuration: {
            screens: {
              ContentFeedList: 'content-curation',
              ContentFeedDetail: 'content-curation/:id'
            }
          },
          Doclets: {
            screens: {
              DocletList: 'doclets',
              DocletEdit: 'doclets/:id/edit'
            }
          },
          CommunitiesMicrositesPermissions: 'communities-microsites',
          UrlShortener: 'url-shortener',
          DataExtraction: 'data-extraction',
          MessageLog: 'message-log'
        }
      }
    }
  }
}

export default linkingOptions
